/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AddressUsageType = {
    MainDomicile: 'MAIN_DOMICILE',
    Domicile: 'DOMICILE',
    Correspondence: 'CORRESPONDENCE',
    TaxDomicile: 'TAX_DOMICILE',
    HoldMailDispatch: 'HOLD_MAIL_DISPATCH',
    Residence: 'RESIDENCE',
    MailDispatch: 'MAIL_DISPATCH'
} as const;
export type AddressUsageType = typeof AddressUsageType[keyof typeof AddressUsageType];


export function instanceOfAddressUsageType(value: any): boolean {
    for (const key in AddressUsageType) {
        if (Object.prototype.hasOwnProperty.call(AddressUsageType, key)) {
            if (AddressUsageType[key as keyof typeof AddressUsageType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AddressUsageTypeFromJSON(json: any): AddressUsageType {
    return AddressUsageTypeFromJSONTyped(json, false);
}

export function AddressUsageTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressUsageType {
    return json as AddressUsageType;
}

export function AddressUsageTypeToJSON(value?: AddressUsageType | null): any {
    return value as any;
}

export function AddressUsageTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AddressUsageType {
    return value as AddressUsageType;
}

